import { render, staticRenderFns } from "./IconMediaImage.vue?vue&type=template&id=253f1e26"
import script from "./IconMediaImage.vue?vue&type=script&lang=js"
export * from "./IconMediaImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports